"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var idlUtils = require("../generated/utils.js");

var DOMException = require("domexception/webidl2js-wrapper");

var _require = require("../node-document-position"),
    DOCUMENT_POSITION_CONTAINS = _require.DOCUMENT_POSITION_CONTAINS,
    DOCUMENT_POSITION_CONTAINED_BY = _require.DOCUMENT_POSITION_CONTAINED_BY;

var Element = require("../generated/Element");

var Node = require("../generated/Node");

var HTMLCollectionImpl = require("./HTMLCollection-impl").implementation;

exports.implementation = /*#__PURE__*/function (_HTMLCollectionImpl, _idlUtils$supportedPr, _idlUtils$indexedSetN, _idlUtils$indexedSetE) {
  _inherits(HTMLOptionsCollectionImpl, _HTMLCollectionImpl);

  var _super = _createSuper(HTMLOptionsCollectionImpl);

  function HTMLOptionsCollectionImpl() {
    _classCallCheck(this, HTMLOptionsCollectionImpl);

    return _super.apply(this, arguments);
  }

  _createClass(HTMLOptionsCollectionImpl, [{
    key: "length",
    get: // inherits supported property indices
    function get() {
      this._update();

      return this._list.length;
    },
    set: function set(value) {
      this._update();

      if (value > this._list.length) {
        var doc = this._element._ownerDocument;

        for (var i = this._list.length; i < value; i++) {
          var el = doc.createElement("option");

          this._element.appendChild(el);
        }
      } else if (value < this._list.length) {
        for (var _i = this._list.length - 1; _i >= value; _i--) {
          var _el = this._list[_i];

          this._element.removeChild(_el);
        }
      }
    }
  }, {
    key: _idlUtils$supportedPr,
    get: function get() {
      this._update();

      var result = new Set();

      var _iterator = _createForOfIteratorHelper(this._list),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;
          result.add(element.getAttributeNS(null, "id"));
          result.add(element.getAttributeNS(null, "name"));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return result;
    }
  }, {
    key: _idlUtils$indexedSetN,
    value: function value(index, _value) {
      if (_value === null) {
        this.remove(index);
        return;
      }

      this._update();

      var length = this._list.length;
      var n = index - length;

      if (n > 0) {
        var doc = this._element._ownerDocument;
        var frag = doc.createDocumentFragment(); // Spec says n - 1, but n seems to be the right number here.

        for (var i = 0; i < n; i++) {
          var el = doc.createElement("option");
          frag.appendChild(el);
        }

        this._element._append(frag);
      }

      if (n >= 0) {
        this._element._append(_value);
      } else {
        this._element._replace(_value, this._list[index]);
      }
    }
  }, {
    key: _idlUtils$indexedSetE,
    value: function value(index, _value2) {
      return this[idlUtils.indexedSetNew](index, _value2);
    }
  }, {
    key: "add",
    value: function add(element, before) {
      if (this._element.compareDocumentPosition(element) & DOCUMENT_POSITION_CONTAINS) {
        throw DOMException.create(this._globalObject, ["The operation would yield an incorrect node tree.", "HierarchyRequestError"]);
      }

      if (Element.isImpl(before) && !(this._element.compareDocumentPosition(before) & DOCUMENT_POSITION_CONTAINED_BY)) {
        throw DOMException.create(this._globalObject, ["The object can not be found here.", "NotFoundError"]);
      }

      if (element === before) {
        return;
      }

      var reference = null;

      if (Node.isImpl(before)) {
        reference = before;
      } else if (typeof before === "number") {
        this._update();

        reference = this._list[before] || null;
      }

      var parent = reference !== null ? reference.parentNode : this._element;

      parent._preInsert(element, reference);
    }
  }, {
    key: "remove",
    value: function remove(index) {
      this._update();

      if (this._list.length === 0) {
        return;
      }

      if (index < 0 || index >= this._list.length) {
        return;
      }

      var element = this._list[index];

      element.parentNode._remove(element);
    }
  }, {
    key: "selectedIndex",
    get: function get() {
      return this._element.selectedIndex;
    }
  }, {
    key: "selectedIndex",
    set: function set(value) {
      this._element.selectedIndex = value;
    }
  }]);

  return HTMLOptionsCollectionImpl;
}(HTMLCollectionImpl, idlUtils.supportedPropertyNames, idlUtils.indexedSetNew, idlUtils.indexedSetExisting);